import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  errorCode: string;
  onDismiss: () => void;
  onContact: (message?: string) => Promise<void>;
};

type SendState = 'idle' | 'sending' | 'sent' | 'failed';

export function CapacityReachedPanel({ errorCode, onDismiss, onContact }: Props) {
  const { t } = useTranslation();
  const [sendState, setSendState] = useState<SendState>('idle');

  async function handleContact() {
    if (sendState === 'sending' || sendState === 'sent') return;
    setSendState('sending');
    try {
      await onContact();
      setSendState('sent');
    } catch {
      setSendState('failed');
    }
  }

  return (
    <div className="capacity-panel" role="dialog" aria-modal="true">
      <div className="capacity-panel__card">
        <h2>{t('stories.dailyCapacity.heading')}</h2>
        <p>{t('stories.dailyCapacity.body')}</p>
        <p className="capacity-panel__code">
          <span>{t('stories.dailyCapacity.errorCodeLabel')}</span>
          <code>{errorCode}</code>
        </p>
        <div className="capacity-panel__actions">
          <button
            type="button"
            className="capacity-panel__contact"
            onClick={handleContact}
            disabled={sendState === 'sending' || sendState === 'sent'}
          >
            {sendState === 'sending' && t('stories.dailyCapacity.contactSending')}
            {sendState === 'sent' && t('stories.dailyCapacity.contactSent')}
            {(sendState === 'idle' || sendState === 'failed') &&
              t('stories.dailyCapacity.contactCta')}
          </button>
          <button type="button" className="capacity-panel__dismiss" onClick={onDismiss}>
            {t('common.close')}
          </button>
        </div>
        {sendState === 'failed' && (
          <p className="capacity-panel__failed">{t('stories.dailyCapacity.contactFailed')}</p>
        )}
      </div>
    </div>
  );
}
